// Funciones
import { ROUTES } from "../../../../../const/routes";

/**
 * Assets de los valores ganadores de la ruleta
 * @param {*} scene 
 */
export function cargaAssetsValoresGanadores(scene) {
  // Bucle para cargar las imágenes de valorGanador desde 0 hasta 48
  for (let i = 0; i <= 48; i++) {
    scene.load.image(
      `valorGanador${i}`,
      `${ROUTES.rutaRuletaValoresGanadores}/valorGanador${i}Resized.png`
    );
  }
}